function Logo(props: { className?: string }) {
  return (
    <a href="/" {...props}>
      <img src="/images/logo_bstr.svg" alt="BSTR" height="59" />
    </a>
  );
}

export default Logo;
